import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { ThemeProvider } from './context/ThemeContext';
import { NotificationProvider } from './context/NotificationContext';
import { PermissionProvider } from './context/PermissionContext';
import { FullscreenProvider } from './context/FullscreenContext';
import AppRoutes from './AppRoutes';

const App = () => {
  useEffect(() => {
    // Save original fetch
    const originalFetch = window.fetch;
    
    // Override global fetch to automatically add Authorization header
    window.fetch = async function(url, options = {}) {
      // Convert url to string for route checking
      const urlString = typeof url === 'string' ? url : url.url || url.toString();
      
      // Skip for public routes that don't need authentication
      const publicRoutes = [
        '/api/auth/login',
      ];
      
      const isPublicRoute = publicRoutes.some(route => 
        urlString.includes(route)
      );
      
      // Only add Authorization header for non-public routes
      if (!isPublicRoute) {
        const token = localStorage.getItem('token');
        if (token) {
          const headers = {
            ...options.headers,
            'Authorization': `Bearer ${token}`,
          };
          
          options = {
            ...options,
            headers,
          };
        }
      }
      
      // Call original fetch
      return originalFetch(url, options);
    };
    
    // Cleanup function to restore original fetch if needed
    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  return (
    <ThemeProvider>
      <LanguageProvider>
        <NotificationProvider>
          <BrowserRouter>
            <FullscreenProvider>
              <PermissionProvider>
                <AppRoutes />
              </PermissionProvider>
            </FullscreenProvider>
          </BrowserRouter>
        </NotificationProvider>
      </LanguageProvider>
    </ThemeProvider>
  );
};

export default App;
